import { DOWNLOAD_ALL_LEADS, DOWNLOAD_ALL_LEADS_ERR } from '../../actionTypes/leadsType'
import { downloadAllLeadsApi } from 'api/Api';
import axios from "axios";
import { accessToken } from 'api/Token'
export const downloadAllLeads = (payload) => async (dispatch) => {
    try {
        let results = await axios.get(`${downloadAllLeadsApi}/${payload.page}`, await accessToken())
        let data = results && results.data
        console.log('GET Leads', data)
        dispatch({
            type: DOWNLOAD_ALL_LEADS,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: DOWNLOAD_ALL_LEADS_ERR,
            payload: error.response,
        });
    }
};


